import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const manyObjectPointingExample: TemplateDefinition = {
  mode: "compose",
  slug: "many-object-pointing-example",
  version: 1,
  title: "Infrastructure",
  description: "Classify and count",
  subdescription: "Segment multiple objects by type and count",
  thumbnailUuid: BASE_ASSETS.manyObjectPointingExample.uuid,
  assets: [BASE_ASSETS.manyObjectPointingExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.manyObjectPointingExample.uuid,
              extension: BASE_ASSETS.manyObjectPointingExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: { type: "text", value: "Find the homes, cars, and pools." },
      },
    ],
    outputAnnotations: false,
    variables: {},
    annotationFormat: "box",
    enableThinking: false,
  } satisfies DocumentInputContentV1,
};
